export default __webpack_public_path__ + "static/media/mytologi.220e5204.jpg";